import Col from './Col';
export default Col;
//# sourceMappingURL=index.js.map